import type {AppThunk} from '../../../actions/types'
import {getSingleProjectArg} from '../../../rest/projects'
import {getTabsArg} from '../../../rest/tabs'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../routes/loadEndpoint'
import {restApi} from '../../../services/rest'
import type {ProjectId} from '../../../types'
import {ProjectPageTabNamesEnum} from '../../../types'
import {isInvestigationsTabEnabled} from '../../../utils/featureToggles'
import {getTabParamsKey} from '../../../utils/tabs'
import {preloadProjectToolbar} from '../../common/ProjectToolbar/ProjectToolbar.preload'

import {preloadProjectInvestigationsTab} from './ProjectInvestigationsTab/ProjectInvestigationsTab.preload'

export const preloadProjectPage =
  ({
    projectId,
    projectTab,
    isInvestigationsTreeExpanded = true,
    isFavoriteProjectsPage,
    onlyFavorites,
  }: {
    projectId: ProjectId
    projectTab?: string | null
    isInvestigationsTreeExpanded?: boolean
    isFavoriteProjectsPage?: boolean
    onlyFavorites?: boolean
  }): AppThunk<LoadedEndpoints> =>
  dispatch => {
    const preloadedEndpoints: LoadedEndpoints = [
      dispatch(
        loadEndpoint(
          restApi.endpoints.getProjectNormalized,
          getSingleProjectArg(projectId, {withAncestorProjects: true}),
        ),
      ),
      ...dispatch(preloadProjectToolbar({projectId, onlyFavorites})),
    ]

    if (!isFavoriteProjectsPage) {
      preloadedEndpoints.push(
        dispatch(loadEndpoint(restApi.endpoints.getTabs, getTabsArg(getTabParamsKey({projectId})))),
      )
    }

    if (isInvestigationsTabEnabled && projectTab === ProjectPageTabNamesEnum.INVESTIGATIONS) {
      preloadedEndpoints.push(
        ...dispatch(
          preloadProjectInvestigationsTab({
            projectId,
            isTestsTreeExpanded: isInvestigationsTreeExpanded,
          }),
        ),
      )
    }

    return preloadedEndpoints
  }
